
        import { CookieConsentController } from '/src/services/cookieConsentController.ts';
        import { Analytics } from '/src/services/analytics.ts';
        import '/src/utils/emojiManager.ts';

        document.addEventListener('DOMContentLoaded', () => {
            new CookieConsentController();
            const analytics = new Analytics('MySpeedTools Feedback', '1.0');

            // Connectivity check
            const form = document.querySelector('.feedback-form');
            const feedbackHeader = document.querySelector('.feedback-header');
            const offlineMessage = document.getElementById('offlineMessage');
            const retryConnectionButton = document.getElementById('retryConnectionButton');

            const checkConnectivity = async () => {
                // Start with navigator.onLine as the primary indicator
                let isOnline = navigator.onLine;
                
                // Only do network check if navigator.onLine is true
                // This prevents false negatives from fetch failures
                if (isOnline) {
                    try {
                        // Try to fetch with a short timeout
                        const controller = new AbortController();
                        const timeoutId = setTimeout(() => controller.abort(), 3000);
                        
                        const response = await fetch(`https://docs.google.com/favicon.ico?_=${Date.now()}`, {
                            method: 'GET',
                            cache: 'no-store',
                            signal: controller.signal
                        });
                        
                        clearTimeout(timeoutId);
                        
                        // If fetch succeeds with good status, we're definitely online
                        if (response.ok || response.status === 404) {
                            isOnline = true;
                        }
                        // Note: We don't set isOnline = false on fetch errors anymore
                        // because the fetch might fail due to CORS, ad blockers, etc.
                        // We trust navigator.onLine if the fetch fails
                    } catch (error) {
                        // Network error or timeout
                        // Only treat as offline if we can't reach the network at all
                        // and navigator.onLine is false
                        console.log('Connectivity check failed:', error.name, error.message);
                        // Keep isOnline as true (trust navigator.onLine)
                        // The offline event will handle actual disconnection
                    }
                }
                
                if (isOnline) {
                    // User is online - show form
                    if (form) form.style.display = 'flex';
                    if (feedbackHeader) feedbackHeader.style.display = 'block';
                    if (offlineMessage) offlineMessage.style.display = 'none';
                } else {
                    // User is offline - show offline message
                    if (form) form.style.display = 'none';
                    if (feedbackHeader) feedbackHeader.style.display = 'none';
                    if (offlineMessage) offlineMessage.style.display = 'flex';
                    
                    analytics.trackEvent('feedback_offline_detected', {
                        timestamp: new Date().toISOString()
                    });
                }
            };

            // Initial check
            checkConnectivity();

            // Listen for online/offline events
            window.addEventListener('online', () => {
                checkConnectivity();
                analytics.trackEvent('feedback_connectivity_restored', {
                    timestamp: new Date().toISOString()
                });
            });

            window.addEventListener('offline', () => {
                checkConnectivity();
                analytics.trackEvent('feedback_connectivity_lost', {
                    timestamp: new Date().toISOString()
                });
            });

            // Handle retry button
            if (retryConnectionButton) {
                retryConnectionButton.addEventListener('click', async () => {
                    // Show loading state
                    const originalText = retryConnectionButton.innerHTML;
                    retryConnectionButton.disabled = true;
                    retryConnectionButton.innerHTML = `
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" style="margin-right: 8px; animation: spin 1s linear infinite;">
                            <path d="M14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2C9.84776 2 11.5161 2.81883 12.6181 4.11803" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                            <path d="M12 2V4.5H9.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        Checking...
                    `;
                    
                    analytics.trackEvent('feedback_retry_connection_clicked', {
                        timestamp: new Date().toISOString()
                    });
                    
                    await checkConnectivity();
                    
                    // Restore button state if still offline
                    setTimeout(() => {
                        if (offlineMessage && offlineMessage.style.display === 'flex') {
                            retryConnectionButton.innerHTML = originalText;
                            retryConnectionButton.disabled = false;
                        }
                    }, 500);
                });
            }

            // Handle back link navigation
            const backLink = document.getElementById('backLink');
            if (backLink) {
                backLink.addEventListener('click', (e) => {
                    e.preventDefault();
                    if (window.history.length > 1) {
                        window.history.back();
                    } else {
                        window.location.href = '/';
                    }
                });
            }

            // Handle form submission
            const thankYouMessage = document.getElementById('thankYouMessage');
            const thankYouButton = document.getElementById('thankYouButton');
            const hiddenIframe = document.querySelector('iframe[name="hidden_iframe"]');
            let countdownInterval = null;
            let countdownSeconds = 10;

            // Function to navigate back
            const navigateBack = () => {
                if (window.history.length > 1) {
                    window.history.back();
                } else {
                    window.location.href = '/';
                }
            };

            // Function to start countdown
            const startCountdown = () => {
                countdownSeconds = 10;
                thankYouButton.textContent = `Going back in ${countdownSeconds}...`;
                
                countdownInterval = setInterval(() => {
                    countdownSeconds--;
                    if (countdownSeconds > 0) {
                        thankYouButton.textContent = `Going back in ${countdownSeconds}...`;
                    } else {
                        clearInterval(countdownInterval);
                        navigateBack();
                    }
                }, 1000);
            };

            if (form && thankYouMessage) {
                // Track form submission success
                form.addEventListener('submit', (e) => {
                    const feedbackType = document.getElementById('feedbackType').value;
                    const feedbackMessage = document.getElementById('feedbackMessage').value;
                    const hasEmail = document.getElementById('feedbackEmail').value !== '';
                    
                    // Track submission attempt
                    analytics.trackEvent('feedback_submitted', {
                        feedback_type: feedbackType,
                        has_email: hasEmail,
                        message_length: feedbackMessage.length,
                        status: 'attempted',
                        timestamp: new Date().toISOString()
                    });

                    // Let the form submit to the iframe
                    setTimeout(() => {
                        // Hide form and show thank you message
                        form.style.display = 'none';
                        document.querySelector('.feedback-header').style.display = 'none';
                        thankYouMessage.style.display = 'block';
                        
                        // Track successful submission display
                        analytics.trackEvent('feedback_submitted', {
                            feedback_type: feedbackType,
                            has_email: hasEmail,
                            message_length: feedbackMessage.length,
                            status: 'success',
                            timestamp: new Date().toISOString()
                        });
                        
                        // Start countdown
                        startCountdown();
                    }, 500);
                });

                // Track form submission errors via iframe
                if (hiddenIframe) {
                    hiddenIframe.addEventListener('error', () => {
                        analytics.trackEvent('feedback_submitted', {
                            status: 'failed',
                            error: 'iframe_load_error',
                            timestamp: new Date().toISOString()
                        });
                    });
                }
            }

            // Handle thank you button click (manual override)
            if (thankYouButton) {
                thankYouButton.addEventListener('click', () => {
                    if (countdownInterval) {
                        clearInterval(countdownInterval);
                    }
                    analytics.trackEvent('feedback_manual_navigation', {
                        countdown_remaining: countdownSeconds,
                        timestamp: new Date().toISOString()
                    });
                    navigateBack();
                });
            }
        });
    